import { type KeyTranslatedValueBlock } from '../_generated/gql-generated';

export type KeyTranslatedValueContentArea = Array<
  Nullable<{
    ContentLink?: Nullable<{
      Expanded?: Nullable<{ __typename?: Nullable<string> }>;
    }>;
  }>
>;

export const extractKeyValueBlocks = (
  items: Nullable<KeyTranslatedValueContentArea> | undefined
): KeyTranslatedValueBlock[] =>
  (items ?? [])
    .map((entry) => entry?.ContentLink?.Expanded)
    .filter((expanded) => expanded?.__typename === 'KeyTranslatedValueBlock')
    .map((expanded) => expanded as KeyTranslatedValueBlock);

export const extractKeyValueOptions = <T extends string>(
  items: Nullable<KeyTranslatedValueContentArea> | undefined,
  allowedKeys: Set<string>
): Array<{ label: string; value: T }> =>
  extractKeyValueBlocks(items)
    .filter((block) => Boolean(block.Key && block.Value && allowedKeys.has(block.Key)))
    .map(({ Key, Value }) => ({ label: Value ?? '', value: Key as T }));
